<div class="callback-container">
  <h2 class="pb-2">Verifying your payment...</h2>
  <p>Please do not refresh or close this page.</p>
  <!-- You can add a loading spinner here -->
</div>
